import { compose_title, quote_title, reply_title } from '@paraglide/messages';
export function getModalTitle(mode) {
    switch(mode){
        case 'reply':
            return reply_title();
        case 'quote':
            return quote_title();
        default:
            return compose_title();
    }
}
